<template>
  <div class="chuKuZuoyeWarp">
    <div class="chuKuZuoyeWarp-body">
        <div class="detailsTitle">
          <h4>{{title}}</h4>
        </div>
        <div class="top">
          <div>
            <p style="display:flex;margin-left:20px;">
              账户金额：
              <span>
                <el-tooltip class="item" effect="dark" placement="right">
                  <div slot="content">账户金额=可用金额+提现中金额</div>
                  <div class='icon'>
                    <img src="../../../../assets/images/wenhao.png" alt="">
                  </div>
                </el-tooltip>
              </span>
              <span style="font-size:18px;color:red;font-weight:600;">&nbsp;&nbsp;&nbsp;{{topData.accountMoney}}&nbsp;&nbsp;&nbsp;</span>
              <span>元</span>
              <span class="font" @click="bankcardClick">银行卡</span>
               <el-dropdown class="my-dropdown">
                <span class="el-dropdown-link">
                  <span class="font2">交易密码</span>
                  <span><img src="../../../../assets/images/downBotttom.png" class="img" alt=""></span>
                </span>
                <!--  slot="dropdown" 插槽 -->
                <el-dropdown-menu slot="dropdown">
                  <el-dropdown-item icon="el-icon-edit-outline" @click.native="changePassWordClick()">修改交易密码</el-dropdown-item>
                  <el-dropdown-item icon="el-icon-unlock" @click.native="setUp()">设置/忘记交易密码</el-dropdown-item>
                </el-dropdown-menu>
              </el-dropdown>
            </p>
            <p style="display:flex;margin-left:20px;">
               <!--<span>可用金额：</span>
              <span>
                <el-tooltip class="item" effect="dark" placement="right">
                  <div slot="content">可用金额=运费收入合计-提现完成金额合计-提现中金额合计</div>
                  <div class='icon'>
                    <img src="../../../../assets/images/wenhao.png" alt="">
                  </div>
                </el-tooltip>
              </span>
              <span>&nbsp;&nbsp;&nbsp;{{topData.accountMoney}}&nbsp;&nbsp;&nbsp;</span><span>元</span> -->
              <span >提现中的金额：</span>
              <span>
                <el-tooltip class="item" effect="dark"  placement="right">
                  <div slot="content">提现中金额，指申请提现单还未提现完成的金额合计</div>
                  <div class='icon'>
                    <img src="../../../../assets/images/wenhao.png" alt="">
                  </div>
                </el-tooltip>
              </span>
              <span>&nbsp;&nbsp;&nbsp;{{topData.wdrawalsBalance}}&nbsp;&nbsp;&nbsp;</span><span>元</span>
            </p>
          </div>
          <div class="top_right">
            <!-- <el-button type="primary" size="" @click="chongZhiClick">充值</el-button>&nbsp;&nbsp;&nbsp; -->
            <el-button type="primary" size="" @click="withdrawalClick" btnCode="00JP00DB003" v-if="btnFlg[2]">提现</el-button>
            <!-- <el-button type="text"    @click="tixianjinduFn()">提现详情</el-button> -->
          </div>
        </div>
         <div class="searchBox" ref="searchBox">
      <el-form :inline="true" ref="" class="demo-form-inline" label-width="110px" size="mini">
        <div class="searchBox inpBox">
            <div class="item">
             <el-form-item label="业务单号:" prop="transSerialno">
                <el-input  placeholder="" v-model="searchFrom.transSerialno"></el-input>
              </el-form-item>
              <el-form-item label="交易类型:" prop="extertransType" >
                <el-select  v-model="searchFrom.extertransType"   placeholder="请选择">
                  <!-- <el-option label="充值" value="1"></el-option> -->
                   <el-option label="运费收入" value="5"></el-option>
                  <el-option label="提现" value="3"></el-option>
                  <!-- <el-option label="邮费支出" value="4"></el-option> -->
                </el-select>
              </el-form-item>
               <el-form-item label="付款账户名称:" prop="customerName">
                <el-input  placeholder="" v-model="searchFrom.customerName"></el-input>
              </el-form-item>
               <el-form-item label="收款账户名称:" prop="recCustomerName">
                <el-input  placeholder="" v-model="searchFrom.recCustomerName"></el-input>
              </el-form-item>
              <el-form-item label="交易时间:" prop="transTimes">
                <el-date-picker
                  v-model="searchFrom.transTimes"
                  format="yyyy-MM-dd"
                  value-format="yyyy-MM-dd"
                  type="daterange"
                  range-separator="至"
                  start-placeholder="开始日期"
                  end-placeholder="结束日期"
                ></el-date-picker>
              </el-form-item>
            </div>
        </div>
        <div class="searchBtnBox">
               <el-form-item btnCode="00JP008B001" v-if="btnFlg[0]">
                <el-button type="primary" @click="searchFn">查询</el-button>
              </el-form-item>
              <el-form-item>
                <el-button type="primary" @click="resetForm('searchFrom')">重置</el-button>
              </el-form-item>
              <el-form-item>
                <el-button type="primary" btnCode="00JP008B004" v-if="btnFlg[3]"  @click="exportFn" :disabled="isDisable">导出</el-button>
              </el-form-item>
            </div>
      </el-form>
    </div>
    <!--  表格 -->
    <div class="table" :style="{height:h}">
       <el-table :data="tableList"  ref="table" v-loading="loading"   bordersize="mini"  @selection-change='selectGoods' height="100%" style="width: 100%" center border>
        <el-table-column type="selection" width="55"></el-table-column>
        <el-table-column type="index" fixed prop="date" width="55" label="序号"></el-table-column>
        <!-- <el-table-column label="操作" width="90">
            <template slot-scope="scope">
              <el-button type="text" size="mini" btnCode="006P009B002"  @click="jiaoyiFn(scope.row)">回单</el-button>
            </template>
        </el-table-column> -->
         <el-table-column property="transNo" width="240"  :formatter="emptyFn"   label="平台流水号"></el-table-column>
         <el-table-column property="zxTansferNo" width="200"  :formatter="emptyFn"   label="银行流水号"></el-table-column>
         <el-table-column property="transSerialno" width="200"  :formatter="emptyFn"   label="业务单号"></el-table-column>
        <el-table-column property="extertransType" label="交易类型">
          <template scope="scope">
            <div>
            <span v-if="scope.row.extertransType==5">运费收入</span>
            <span v-if="scope.row.extertransType==3">提现</span>
            </div>
          </template>
        </el-table-column>
        <el-table-column property="customerName"  width="320"  :formatter="emptyFn"   label="付款账户名称"></el-table-column>
        <el-table-column property="zxAccNo"  width="220"  :formatter="emptyFn"   label="付款银行账号"></el-table-column>
        <el-table-column property="recCustomerName"  width="200"  :formatter="emptyFn"   label="收款账户名称"></el-table-column>
        <!-- <el-table-column property="customerAccount"  width="120"  :formatter="emptyFn"   label="付款平台账号"></el-table-column>
        <el-table-column property="recCustomerAcount"  width="120"  :formatter="emptyFn"   label="收款平台账号"></el-table-column> -->
        <!-- <el-table-column property="lastAccountMoney" width="150"   :formatter="emptyFn"   label="交易前平台余额(元)"></el-table-column> -->
        <el-table-column property="transMoney"  width="120"  :formatter="emptyFn"   label="交易金额(元)"></el-table-column>
        <!-- <el-table-column property="accountMoney"  width="120"  :formatter="emptyFn"   label="交易后平台余额(元)"></el-table-column> -->
        <el-table-column width="170" property="transTime" :formatter="dateTimeFormat" label="交易时间"></el-table-column>
      </el-table>
    </div>
     <!-- 分页 -->
    <div>
      <el-pagination background
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        :current-page="searchFrom.pageNo"
        :page-sizes="[25,50,100]"
        :page-size="searchFrom.pageSize"
        layout="total, sizes, prev, pager, next, jumper"
        :total="total">
      </el-pagination>
    </div>
    <!-- 修改交易密码 -->
    <el-dialog :title="title"
    :close-on-click-modal="false"
    :close-on-press-escape="false"
    :visible.sync="changePasswordMark"
    @close="reset('changePasswordFrom')"
    width="500px"
    center>
      <span>
         <el-form
          :model="changePasswordFrom"
          :rules = rules
          :validate-on-rule-change = "false"
          ref="changePasswordFrom"
          class="demo-form-inline"
          label-width="140px" size="mini">
        <div class="addinpBox" >
          <el-form-item label="" prop="" style="margin-top:20px;">
            <span style="color:#ccc;">提示：交易密码为6位数字</span>
          </el-form-item>
          <el-form-item label="原密码:" prop="oldPwd" style="margin-top:20px;">
            <el-input  show-password placeholder="" v-number-input.float="0" maxlength=""  v-model.trim="changePasswordFrom.oldPwd" style="width:200px;"></el-input>
          </el-form-item>
          <el-form-item label="新密码:" prop="newPwd" style="margin-top:20px;">
            <el-input  show-password placeholder="" v-number-input.float="0" maxlength="6"  v-model.trim="changePasswordFrom.newPwd" style="width:200px;"></el-input>
          </el-form-item>
          <el-form-item label="确认密码:" prop="newPwdOne" style="margin-top:20px;">
            <el-input  show-password placeholder="" v-number-input.float="0" maxlength="6"  v-model.trim="changePasswordFrom.newPwdOne" style="width:200px;"></el-input>
          </el-form-item>
        </div>
        </el-form>
      </span>
      <span slot="footer" class="dialog-footer">
        <el-button type="primary" size='mini'  @click="settlementSubmit('changePasswordFrom')"  :loading='SubmitLoading'>修改</el-button>
        <el-button @click="settlementClose('changePasswordFrom')" size='mini'>取 消</el-button>
      </span>
    </el-dialog>
    <!-- 设置交易密码 -->
    <el-dialog :title="title"
    :close-on-click-modal="false"
    :close-on-press-escape="false"
    :visible.sync="setUpPasswordMark"
    @close="reset('setUpPasswordFrom')"
    width="500px"
    center>
      <span>
         <el-form
          :model="setUpPasswordFrom"
          :rules = rules2
          :validate-on-rule-change = "false"
          ref="setUpPasswordFrom"
          class="demo-form-inline"
          label-width="140px" size="mini">
        <div class="addinpBox" >
          <el-form-item label="" prop="" style="margin-top:20px;">
            <span style="color:#ccc;">提示：交易密码为6位数字</span>
          </el-form-item>
          <el-form-item label="手机号:" prop="receivePhone" style="margin-top:20px;">
            <span>{{setUpPasswordFrom.receivePhone}}</span>
          </el-form-item>
          <el-form-item label="验证码:" prop="code" style="margin-top:20px;">
            <el-input  placeholder="" v-number-input.float="0" maxlength=""  v-model.trim="setUpPasswordFrom.code" style="width:100px;"></el-input>
            <el-button  size='mini' type="primary" v-if="isShowGetCode" auto-complete="new-password" @click="codeClick">获取验证码</el-button>
             <span v-else class="identiCode"
                >{{ countdown }}s后可重试</span
              >
          </el-form-item>
          <el-form-item label="设置密码:" prop="newPwd" style="margin-top:20px;">
            <el-input  show-password placeholder="" auto-complete="new-password" v-number-input.float="0" maxlength="6"  v-model.trim="setUpPasswordFrom.newPwd" style="width:200px;"></el-input>
          </el-form-item>
          <el-form-item label="确认密码:" prop="newPwdOne" style="margin-top:20px;">
            <el-input  show-password placeholder="" v-number-input.float="0" maxlength="6"  v-model.trim="setUpPasswordFrom.newPwdOne" style="width:200px;"></el-input>
          </el-form-item>
        </div>
        </el-form>
      </span>
      <span slot="footer" class="dialog-footer">
        <el-button type="primary" size='mini'  @click="setUpSubmit('setUpPasswordFrom')"  :loading='setSubmitLoading'>确定</el-button>
        <el-button @click="setUpClose('setUpPasswordFrom')" size='mini'>取 消</el-button>
      </span>
    </el-dialog>
    </div>
    <!-- 提现详情 -->
    <tixianjinduList  :row-data="topData" v-if="zujianFlag" @destroy="destroy"></tixianjinduList>
  </div>
</template>
<script>
import DonMessage from '@/utils/message'
import { encryption, emptyFn, dateTimeFormat } from '@/utils/util'
import { getBtn } from '@/utils/getButton'
import {
  getPayDetailByPC, // 头部
  tExternalTransdetaiLIst, // 列表
  getDictionaryList, // 字典
  sendSmsCode, // 验证码
  firstUpdateBankCardPayPwd, // 设置密码
  updateBankCardPayPwd // 修改密码
  // listAllCustomer // 查询用户对象列表
} from '@/api/consignment'
import tixianjinduList from '@/components/networkFreight/tixianjinduList.vue'
import { exportExcel } from '@/utils/fileDownXlsx.js'
export default {
  components: {
    tixianjinduList
  },
  name: 'carriage',
  data () {
    return {
      dateTimeFormat: dateTimeFormat,
      emptyFn: emptyFn,
      num: 0,
      title: '资金账户',
      h: '500px',
      // 按钮
      btnFlg: [],
      btnIdArr: ['00JP00DB001', '00JP00DB002', '00JP00DB003', '00JP00DB004'],
      topData: {}, // 头部数据
      tableList: [],
      searchFrom: {
        pageSize: 10,
        pageNo: 1,
        startTime: '',
        endTime: '',
        platetransType: ''
      },
      total: 0,
      platetransTypeOptions: [],
      customerName: '',
      changePasswordMark: false,
      changePasswordFrom: {
        oldPwd: '',
        newPwd: '',
        newPwdOne: ''
      },
      SubmitLoading: false,
      rules: {
        oldPwd: [
          { required: true, message: '请输入原密码', trigger: 'blur' }
        ],
        newPwd: [
          { required: true, message: '请输入新密码', trigger: 'blur' }
        ],
        newPwdOne: [
          { required: true, message: '请输入确认密码', trigger: 'blur' }
        ]
      },
      rules2: {
        receivePhone: [
          { required: true, message: '手机号不能为空', trigger: 'blur' }
        ],
        code: [
          { required: true, message: '请输入验证码', trigger: 'blur' }
        ],
        newPwd: [
          { required: true, message: '请设置密码', trigger: 'blur' }
        ],
        newPwdOne: [
          { required: true, message: '请确认密码', trigger: 'blur' }
        ]
      },
      setUpPasswordMark: false,
      setUpPasswordFrom: {
        id: '',
        receivePhone: '',
        code: '',
        newPwd: '',
        newPwdOne: ''
      },
      accountId: '',
      setSubmitLoading: false,
      isShowGetCode: true,
      countdown: 60,
      timer: '',
      zujianFlag: false,
      isDisable: false,
      loading: false
    }
  },
  created () {
    this.btnFlg = getBtn(this.btnIdArr, '/payVehicle/capital')
    this.getAllCustomer()
    this.getTopData()
  },
  mounted () {
    let h = this.$refs.searchBox.offsetHeight // 头部搜索盒子高度
    let pH = document.documentElement.clientHeight // 浏览器高度
    this.h = pH - h - 100 + 'px'
    // 218 ->页面除盒子外的高度
  },
  methods: {
    // 提现进度
    tixianjinduFn () {
      this.zujianFlag = true
    },
    // 组件销毁
    destroy () {
      this.zujianFlag = false
    },
    // 获取验证码
    codeClick () {
      this.countDown()
      this.isShowGetCode = false
      sendSmsCode({
        account: this.setUpPasswordFrom.receivePhone
      }).then(res => {

      }).catch(err => {
        DonMessage.error(err.message)
      })
    },
    countDown () {
      const self = this
      this.timer = setInterval(() => {
        self.countdown--
        if (self.countdown === 0) {
          clearInterval(self.timer)
          self.countdown = 60
          self.isShowGetCode = true
        }
      }, 1000)
    },
    // 获取头部金额
    getTopData () {
      getPayDetailByPC({
        accountType: 3 // 账户类型1-货主 2-司机 3-车队
      }).then(res => {
        this.topData = res
        console.log(res)
        this.accountId = res.id
        this.setUpPasswordFrom.id = res.id
        this.setUpPasswordFrom.receivePhone = this.topData.receivePhone
        // 存手机号
        localStorage.setItem('receivePhone2', res.receivePhone)
        localStorage.setItem('accountId2', res.id)
        localStorage.setItem('bankAccount2', res.bankAccount) // 银行卡
        localStorage.setItem('cardholder2', res.cardholder) // 持卡人
        localStorage.setItem('openingBank2', res.openingBank) // 开户行
        this.getList(this.searchFrom)
      }).catch(err => {
        DonMessage.error(err.message)
      })
    },
    // 查询用户对象列表
    getAllCustomer () {
      // listAllCustomer({
      //   accountType: 3 // 账户类型1-货主 2-司机 3-车队
      // }).then(res => {
      //   console.log(res)
      //   // this.customerName = res[0].customerName
      //   // console.log(this.customerName)
      //   // if (res === []) {
      //   //   DonMessage.error('暂无数据')
      //   // } else {
      //   //   console.log(this.customerName)
      //   // }
      // }).catch(err => {
      //   DonMessage.error(err.message)
      // })
    },
    // 修改密码弹框
    changePassWordClick () {
      this.changePasswordMark = true
      this.title = '修改密码'
    },
    settlementSubmit (formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          let data = encryption({
            data: this.changePasswordFrom,
            key: this.global.key,
            param: ['oldPwd', 'newPwd', 'newPwdOne']
          })
          this.SubmitLoading = true
          updateBankCardPayPwd({
            id: this.setUpPasswordFrom.id,
            oldPwd: data.oldPwd,
            newPwd: data.newPwd,
            newPwdOne: data.newPwdOne
          }).then(res => {
            this.SubmitLoading = false
            DonMessage.success('修改成功')
            this.changePasswordMark = false
            this.changePasswordFrom = {
              oldPwd: '',
              newPwd: '',
              newPwdOne: ''
            }
          }).catch(err => {
            this.SubmitLoading = false
            DonMessage.error(err.message)
          })
          // alert('submit!');
        } else {
          // console.log('error submit!!');
          return false
        }
      })
    },
    settlementClose (formName) {
      this.changePasswordMark = false
      this.$refs[formName].resetFields()
    },
    // 点击设置密码
    setUp () {
      this.setUpPasswordMark = true
      this.title = '设置密码'
    },
    // 设置密码确定
    setUpSubmit (formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          let data = encryption({
            data: this.setUpPasswordFrom,
            key: this.global.key,
            param: ['newPwd', 'newPwdOne']
          })
          this.setSubmitLoading = true
          firstUpdateBankCardPayPwd({
            id: this.setUpPasswordFrom.id,
            receivePhone: this.setUpPasswordFrom.receivePhone,
            code: this.setUpPasswordFrom.code,
            newPwd: data.newPwd,
            newPwdOne: data.newPwdOne
          }).then(res => {
            this.setSubmitLoading = false
            DonMessage.success('设置成功')
            this.setUpPasswordMark = false
            this.isShowGetCode = true
            this.countdown = 60
            clearInterval(this.timer)
            this.setUpPasswordFrom = {
              receivePhone: '',
              code: '',
              newPwd: '',
              newPwdOne: ''
            }
            this.getTopData()
          }).catch(err => {
            this.setSubmitLoading = false
            DonMessage.error(err.message)
          })
          // alert('submit!');
        } else {
          // console.log('error submit!!');
          return false
        }
      })
    },
    // 设置密码取消
    setUpClose (formName) {
      this.setUpPasswordMark = false
      this.$refs[formName].resetFields()
      this.isShowGetCode = true
      this.countdown = 60
      clearInterval(this.timer)
    },
    // 导出
    exportFn () {
      let form = this.searchFrom
      form.accountId = this.accountId
      exportExcel(
        this.global.payServer + '/tExternalTransdetai/exportList',
        form,
        '交易明细列表'
      )
      this.isDisable = true
      setTimeout(() => {
        this.isDisable = false // 点击一次时隔两秒后才能再次点击
      }, 2000)
    },
    // 查选
    searchFn () {
      this.getList(this.searchFrom)
    },
    // 选择数据
    selectGoods (selection) {
      console.log(selection)
      this.weight = 0.00
      selection.forEach(item => {
        this.weight += item.weight
      })
    },
    // 点击选中
    handleRowClick (row, column, event) {
      this.$refs.table.toggleRowSelection(row)
    },
    // 获取列表
    getList (searchFrom) {
      this.loading = true
      tExternalTransdetaiLIst(searchFrom).then(res => {
        this.loading = false
        this.tableList = res.list
        this.total = res.total
      })
    },
    // 每页条数
    handleSizeChange (val) {
      this.searchFrom.pageSize = val
      this.getList(this.searchFrom)
    },
    // 当前页
    handleCurrentChange (val) {
      this.searchFrom.pageNo = val
      this.getList(this.searchFrom)
    },
    // 重置
    resetForm (formName) {
      // debugger
      // this.$refs[formName].resetFields()
      // this.searchFrom.createTime=null
      this.searchFrom = {
        pageNo: 1,
        pageSize: 50,
        extertransTypes: [1, 2, 3, 4, 5]
      }
    },
    // 点击银行卡
    bankcardClick () {
      this.$router.push('/payVehicle/bankcard')
    },
    // 点击充值
    chongZhiClick () {
      this.$router.push('/payCustomer/recharge')
    },
    // 点击提现
    withdrawalClick () {
      if (this.topData.bankAccount != '' && this.topData.lastuserPwd != '') {
        this.$router.push('/payVehicle/withdrawal')
      } else {
        DonMessage.error('请先绑定银行卡并设置交易密码')
      }
    },
    // 点击弹窗x清空数据
    reset (formName) {
      var _this = this
      _this.$refs[formName].resetFields()
    }
  }
}
</script>
<style lang="scss" scoped>
.top{
  width:98%;
  height:100px;
  border:solid 1px #ccc;
  margin: 0 auto;
  display: flex;
  .icon{
    width: 21px;
    height: 21px;
    // background: url('../../../../assets/images/wenhao.png');
    img{
      width: 100%;
    }
  }
  .font{
    cursor: pointer;
    color:#409EFF;
    margin-left:40px;
  }
  .el-dropdown-link{
    display: block;
    // margin-top: -5px;
  }
  .font2{
    cursor: pointer;
    color:#409EFF;
    margin-left:40px;
  }
  .img{
      width: 15px;
      height: 15px;
  }
  .top_right{
    margin-left: 10%;
    margin-top:35px;
  }
}
.my-dropdown {
      float: right;
      .avatar {
        width: 30px;
        height: 30px;
        vertical-align: middle;
        display: inline-block;
      }
      .username {
        color: #fff;
        vertical-align: middle;
        font-size: 12px;
        margin-left: 4px;
      }
    }
.box1B {
  margin-left: 95px !important;

  display: flex !important;
  flex-wrap: wrap !important;
  span {
    // margin-left: 20px !important;
    line-height: 26px !important;
  }
}
.addressBoxTitle {
  div {
    font-size: 22px;
    font-style: 700;
    float: left;
    margin-right: 80px;
  }
}
.addressBoxImg {
  .ul {
    display: flex;
    flex-wrap: wrap;
    li {
      width: 150px;
      height: 150px;
      border-radius: 20px;
      overflow: hidden;
      border: 1px dashed #ccc;
      margin-right: 30px;
      text-align: center;

      img {
        height: 100%;
        width: 100%;
      }
    }
  }
  .ul2 {
    display: flex;
    flex-wrap: wrap;
    li {
      width: 150px;
      margin-right: 30px;

      text-align: center;
    }
  }
}
.huoQuanChangeWarp-body-title {
  width: 100%;
  height: 35px;
  border-bottom: 1px solid #ccc;
  padding: 5px;
  box-sizing: border-box;
  span {
    font-size: 14px;
    font-weight: 700;
    line-height: 20px;
    color: #2f2f2f;
    display: inline;
    line-height: 30px;
    // margin-left: 20px;
  }
}
.chuKuZuoyeWarp {
  width: 100%;
  position: relative;
  height: 100%;
  .pags {
    width: 100%;
    text-align: center;
  }
  // border: solid 1px blue;
  .chuKuZuoyeWarp-body {
    width: 100%;
    position: absolute;

    .chuKuZuoyeWarp-body-queryIpt {
      // margin-top: 5px;
      width: 100%;

      // border: solid 1px;
      display: flex;
      ul {
        flex: 1;
        flex-direction: column;
        display: flex;
        li {
          margin-top: 5px;
          list-style: none;
        }
      }
    }

    .chuKuZuoyeWarp-body-btn {
      margin-top: 5px;
    }
    .chuKuZuoyeWarp-body-table {
      margin-top: 5px;
    }
  }
  /deep/ .el-textarea .el-textarea__inner {
    resize: none;
  }
}
.inpBox {
  margin: 20px 0 10px;
}
.inpBox .el-date-editor{
      width: 350px!important;
}
</style>
